export const features = [
  ['rpm', 'Remote Patient Monitoring'],
  ['kp-auto-ek12', 'KP Auto ek12'],
  ['qt', 'QT'],
  ['qt-display-qt', 'Display QT value'],
  ['qt-display-qtcb', 'Display QTcb value'],
  ['hideqtcorrectiontype', 'Hide QT correction type'],
  ['qt-display-qtcf', 'Display QTcf value'],
  ['qt-display-rr', 'Display RR value'],
  ['qt-display', 'Display QT'],
  ['hide-overread-provider-info', 'Hide Overread Provider Info'],
  ['interpretation-service-provider', 'QT Interpretation Service Provider'],
  ['qt-service-provider', 'QT Service Provider Practice'],
  ['generalize-overread-provider-info', 'Generalize Overread Provider Info'],
  ['clinician-review-portal', 'Clinician Review Portal'],
  ['kpsp-error', 'Show Errors for Service Provider Practice'],
  ['referral', 'Referrals'],
  ['idtf', 'IDTF'],
  ['idtf-service-provider', 'IDTF Service Provider'],
  ['has-api-access', 'API Access'],
  ['medanta-api', 'Medanta API'],
  ['inventory', 'Inventory Management (IMP Phase 1)'],
  ['inventory-reporting', 'Inventory Reporting'],
  ['teleconnect', 'TeleConnect'],
  ['license-management', 'License Management'],
  ['web-onboarding', 'Web Onboarding'],
  ['12lead', '12 Lead'],
  ['is-device-tutorials-enabled', 'Device Tutorials Enabled'],
  ['ebv', 'Enable Electronic Benefit Validation (eBV)'],
  ['technician-view-only', 'Technician View Only'],
  ['super-user', 'Enable super user'],
  ['enable-partner-pdf', 'Enable "Download Overread Report"'],
  ['inactive-practice', 'Inactive Practice']
]
export const featuresMap = new Map(features)

export const FEATURES = {
  INVENTORY: 'inventory',
  LICENSE_MANAGEMENT: 'license-management',
  SUPER_USER: 'super-user',
  INTERPRETATION_SERVICE_PROVIDER: 'interpretation-service-provider',
  QT_SERVICE_PROVIDER: 'qt-service-provider',
  MEDANTA_API: 'medanta-api',
  QT: 'qt'
}

export const FEATURES_LABEL = {
  SUPER_USER_LABEL: 'Enable super user',
  INTERPRETATION_SERVICE_PROVIDER_LABEL: 'QT Service Provider Practice',
  QT_SERVICE_PROVIDER_LABEL: 'QT Interpretation Service Provider'
}

export const checkFeatueEnabled = (FEATURE, teamFeatures) => {
  return teamFeatures ? teamFeatures.find(feature => {
    if (feature.feature === FEATURE && feature.enabled === true) {
      return true
    }
  }) : false
}

export function checkCNOrigin() {
  const CN_URI = 'kardiapro.cn'
  // const LOCAL = 'localhost'
  return window.origin.includes(CN_URI) //|| window.origin.includes(LOCAL)
}



// WEBPACK FOOTER //
// ./src/constants/features.js